import { Injectable } from '@angular/core';
import { MultiplePortsResponse, MultiplePortsResponseData } from '@shared/model/multiple-ports-response.model';
import { ApiBuilderService } from '@shared/services/api-builder.service';
import { Observable, map } from 'rxjs';
const route = '/api/v1/resource';
@Injectable({
  providedIn: 'root'
})
export class PortsService {

  constructor(private apiBuilder: ApiBuilderService) { }
  public getMultiplePorts(transports: number[] ,  data: string, countryCode?: string): Observable<MultiplePortsResponseData[]>{
    return this.apiBuilder.get(`${route}/multiple-ports?transports=[${transports}]&data=${data}&countryCode=${countryCode}`).pipe(map(
      (res: MultiplePortsResponse) => res.data
    ));
  }
}
